/* eslint-disable max-len */
import 'react';

const WarningSvg3 = () => {
    return (
        <svg width="24" height="25" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient x1="0%" y1="6.055%" x2="100%" y2="93.945%" id="wiki_WarningSvg3__a">
                    <stop stopColor="#FF784F" offset="0%" />
                    <stop stopColor="#FF4A4A" offset="100%" />
                </linearGradient>
            </defs>
            <g transform="translate(0 .5)" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M9.385 6.544l-4.988 8.874c-.26.463-.397.987-.397 1.52C4 18.627 5.349 20 7.012 20h9.975c.525 0 1.04-.14 1.495-.404 1.444-.839 1.946-2.71 1.12-4.178l-4.987-8.874a3.038 3.038 0 00-1.12-1.14 2.985 2.985 0 00-4.11 1.14z"
                    fill="url(#wiki_WarningSvg3__a)"
                    opacity=".8"
                />
                <path stroke="#FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M12 14V9" />
                <circle fill="#FFF" fillRule="nonzero" cx="12" cy="17" r="1" />
            </g>
        </svg>
    );
};

export default WarningSvg3;
